import { Box, Card, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MainLayout } from "@shared/ui/MainLayout";
import MDBox from "@vendor/components/MDBox";

import { TableDetails } from "../components/TableDetails";
import { useCurrentPreInvoice } from "../hooks/useCurrentPreInvoice";

// Pantalla visualizadora de prefactura. Conserva los datos de cabecera de
// ejemplo del template original; la tabla de detalle se alimenta de la
// prefactura actual. (El original no pasaba props a la tabla — se corrige el
// wiring evidente para que la ruta no rompa.)
export const PreInvoiceVisualizerPage = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useCurrentPreInvoice();
  const details = data?.details ?? [];

  return (
    <MainLayout loading={isFetching}>
      <MDBox py={3}>
        <Card>
          <MDBox p={2}>
            <Grid container>
              <Grid size={12}>
                <Typography variant="h5">PREFACTURA</Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography variant="h6">Nombre: </Typography>
                  <Typography variant={"p" as "body1"} sx={{ fontSize: 15 }}>
                    {" Jhon Beiker "}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography variant="h6">Número: </Typography>
                  <Typography variant={"p" as "body1"} sx={{ fontSize: 15 }}>
                    {" P00000005 "}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography variant="h6"> Número de pasaporte o ID: </Typography>
                  <Typography variant={"p" as "body1"} sx={{ fontSize: 15 }}>
                    {" P00000005 "}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography variant="h6"> Fecha: </Typography>
                  <Typography variant={"p" as "body1"} sx={{ fontSize: 15 }}>
                    {" 25/08/2022 "}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography variant="h6"> País: </Typography>
                  <Typography variant={"p" as "body1"} sx={{ fontSize: 15 }}>
                    {" Venezuela "}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography variant="h6"> Ciudad: </Typography>
                  <Typography variant={"p" as "body1"} sx={{ fontSize: 15 }}>
                    {" Barquisimeto "}
                  </Typography>
                </Box>
              </Grid>

              <Grid size={12}>
                <TableDetails details={details} t={t} />
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </MainLayout>
  );
};
